import { ButtonT1 } from "../../atoms/Button";
import { PortalFooterCard } from "../../atoms/Footer";

export const PortalFooter = ({
  className,
  isDisabled,
  onApply,
  onCancel,
  applyTitle = "Apply",
  applyVariant = "primary",
  cancelTitle = "Cancel",
  isLoading = false,
}) => {
  return (
    <PortalFooterCard className={className}>
      <ButtonT1
        title={applyTitle}
        $variant={applyVariant}
        onClickCallback={onApply}
        disabled={isDisabled}
        loading={isLoading}
      />
      <ButtonT1
        title={cancelTitle}
        $variant="secondary"
        onClickCallback={onCancel}
        disabled={isLoading}
      />
    </PortalFooterCard>
  );
};
